// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  mapbox: {
    accessToken: 'pk.eyJ1IjoiZmlyZWJ1Z2dpcmwiLCJhIjoiY2l0bjR3aDE3MDM4ODJ0cGNmMDByc3l2NSJ9.tPJEK7dMJb_3j4zhWJ-Uog'
  }
};
